export const freeTrialsQueryKeys = {
  getTrialStageBanner: ['get-trial-stage-banner'],
  getTrialHistory: ['get-trial-history'],
  updateTrialBannerUserAction: (locationId: string) => [locationId, 'update-trial-banner-user-action'],
};
